.dial {
  --size: 108px;
  --knob-radius: -50.5px;

  width: var(--size);
  height: var(--size);
  flex: none;
  position: relative;
  border-radius: 50%;
  padding: 9px;
  touch-action: none;
  cursor: grab;
}

.dial:active {
  cursor: grabbing;
}

.dial[aria-disabled='true'] {
  opacity: 0.45;
  cursor: not-allowed;
}

.face {
  position: absolute;
  inset: 9px;
  border-radius: 50%;
  background: #1b1d2b;
  display: grid;
  place-items: center;
  text-align: center;
  pointer-events: none;
}

.percent {
  font-size: 20px;
  font-weight: 500;
  letter-spacing: -0.02em;
  line-height: 1.1;
}

.unit {
  font-size: 12px;
  color: rgb(233 233 237 / 0.5);
}

.caption {
  font-size: 9px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: rgb(233 233 237 / 0.4);
}

.knob {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 13px;
  height: 13px;
  margin: -6.5px;
  border-radius: 50%;
  background: var(--color-accent-200);
  box-shadow: 0 0 10px rgb(145 132 217 / 0.8);
  pointer-events: none;
}

@media (min-width: 900px) {
  .dial {
    --size: 118px;
    --knob-radius: -55px;
    padding: 10px;
  }

  .face {
    inset: 10px;
  }

  .percent {
    font-size: 23px;
  }

  .unit {
    font-size: 13px;
  }

  .knob {
    width: 14px;
    height: 14px;
    margin: -7px;
  }
}
